/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazySharePointIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-sharepoint" */ './utils').then((m) => m.SharePointIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon' },
);

const LazySharePointSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-sharepoint-search-result" */ './utils').then(
			(m) => m.SharePointSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon' },
);

const LazySharepointIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-sharepoint-borderless" */ './utils').then(
			(m) => m.SharepointIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const SharePointIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySharePointIconComponent />
	</Suspense>
);

export const SharePointSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySharePointSearchResultIconComponent />
	</Suspense>
);

export const SharepointIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySharepointIconBorderlessComponent />
	</Suspense>
);
